export default __webpack_public_path__ + "static/media/Intermediate_CSS_-_adamr.space___Codecademy.b8c1cd31.pdf";